export default "__VITE_ASSET__60367b56__"